import { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';

import { trackProductListFilter } from '~/shared/actions';

import useGridInputs from './useGridInputs';

const useFacetTracking = ({
  selectedUrlFilters: cioFacets,
  selectedSortOption: cioSort,
}) => {
  const dispatch = useDispatch();
  const prevCiofacetsRef = useRef({});
  const prevSort = useRef('');
  const { productSource } = useGridInputs();

  useEffect(() => {
    const previous = prevCiofacetsRef.current;
    const appliedFacets = [];
    const clearedFacets = [];
    const facetKeys =
      cioFacets && Object.keys(cioFacets).length > 0 ? cioFacets : previous;

    Object.keys(facetKeys).forEach((facetKey) => {
      const previousFacetValues = previous[facetKey] || [];
      const currentFacetValues = cioFacets[facetKey] || [];

      const applied = currentFacetValues.filter(
        (item) => !previousFacetValues.includes(item)
      );
      if (applied.length) {
        appliedFacets.push(
          ...applied.map((facetValue) => ({
            label: 'Apply',
            filter: { type: facetKey, value: facetValue },
          }))
        );
      }

      const cleared = previousFacetValues.filter(
        (item) => !currentFacetValues.includes(item)
      );
      if (cleared.length) {
        clearedFacets.push(
          ...cleared.map((facetValue) => ({
            label: 'Clear',
            filter: { type: facetKey, value: facetValue },
          }))
        );
      }
    });

    const filterList = Object.values({ ...appliedFacets, ...clearedFacets });

    filterList.forEach((filterInfo) => {
      dispatch(
        trackProductListFilter({
          label: filterInfo.label,
          filters: filterInfo.filter,
          list_id: productSource,
          sort: [{ field: cioSort }],
        })
      );
    });

    prevCiofacetsRef.current = cioFacets;
  }, [dispatch, cioFacets, cioSort, productSource]);

  const isSortDifferent = prevSort.current && prevSort.current !== cioSort;

  if (isSortDifferent) {
    dispatch(
      trackProductListFilter({
        list_id: productSource,
        sort: [{ field: cioSort }],
      })
    );
  }

  prevSort.current = cioSort;

  return null;
};

export default useFacetTracking;
